/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { defineAbilityFor } from "./components/abilityService/roles";

const is = require("is_js");

const SERVICE_NAME = "AppNavigatorService";
const log: any = LoggerModule.getInstance();

export class AppNavigatorService {
  private static instance: AppNavigatorService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): AppNavigatorService {
    if (!AppNavigatorService.instance) {
      AppNavigatorService.instance = new AppNavigatorService(props);
    }
    return AppNavigatorService.instance;
  }

  public async getContent() {
    let content: any = {};
    let compProps: any = null;

    const agent = getAgent();

    //Whoami Props
    compProps = await agent.whoami({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //User Profile Props
    compProps = await agent.getUserProfile({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //sidebar Props
    compProps = await agent.getSidebarItems({
      whoami: content?.whoami,
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //brand Props
    compProps = await agent.getBrandProfile({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Organisation Props
    compProps = await agent.getOrgProfile({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Routes Props
    compProps = await agent.getRoutes({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Dropdown Props
    compProps = await agent.getDropdownItems({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Footer Props
    compProps = await agent.getFooterProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    console.log("AppNavigator Content =>", content);
    return content;
  }

  public abilityCheck(
    sub: string,
    whoami: string,
    action: "create" | "read" | "update" | "delete" | "manage" = "read"
  ) {
    const ability: any = defineAbilityFor(whoami);
    if (ability) {
      const able = ability.can(action, sub);
      log.blue(
        SERVICE_NAME,
        `actor: ${whoami}, sub: ${sub}, action: read, able: ${able}`
      );
      return able;
    }
    return false;
  }

  public async getSidebarItems(whoami: string) {
    const agent = getAgent();
    return agent.getSidebarItems({
      whoami: whoami,
    });
  }

  public async whoAmI() {
    const agent = getAgent();
    return agent.whoami({});
  }
}
